import React from "react";
import styled, { keyframes } from "styled-components";

export default function Loader() {
  return (
    <>
      <LoaderContainer>
        <Ring>
          <div />
          <div />
          <div />
          <div />
        </Ring>
      </LoaderContainer>
    </>
  );
}

const LoaderContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000000 !important;
`;

const RingAnimation = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const Ring = styled.div`
  display: inline-block;
  position: relative;
  width: 40px;
  height: 40px;
  div {
    box-sizing: border-box;
    
    display: block;
    position: absolute;
    width: 128px;
    height: 128px;
    margin: 4px;
    border: 14px solid ${({ theme }) => theme.color.gray300};
    border-radius: 50%;
    animation: ${RingAnimation} 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: ${({ theme }) => theme.color.gray300} transparent transparent
      transparent;
  }

  div:nth-child(1) {
    animation-delay: -0.45s;
  }

  div:nth-child(2) {
    animation-delay: -0.3s;
  }

  div:nth-child(3) {
    animation-delay: -0.15s;
  }
`;
